import { PSI_OUTPUT_LABELS } from '@/helpers/unit-formatter/shared/constants';
import { FormattedUnitLabels, NumericFormatterInput } from '@/helpers/unit-formatter/shared/types';
import {
  formatNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/shared/utils';

/**
 * Formatter for undecoded psig-inhg composite pressure display. Display-only: no
 * PSIG↔inHG conversion. Sign selects the unit label; magnitude is shown as-is.
 * Only for `none` sources with psig-inhg display, or psig-inhg source before decode.
 *
 * Non-numeric passthrough is handled by `asPassthroughNonNumericFormatter` at registry build.
 */
export function formatPsigInhg({ value }: NumericFormatterInput): FormattedUnitLabels {
  if (value < 0) {
    return unitValueToFormattedUnitLabels({
      value: formatNumber(Math.abs(value)),
      units: PSI_OUTPUT_LABELS.INHG,
    });
  }

  return unitValueToFormattedUnitLabels({
    value: formatNumber(value),
    units: PSI_OUTPUT_LABELS.PSIG,
  });
}
